export const Permission = {
  Production: {
    Mixing: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
      LEADERLINE: ['order-ready'],
      TEAMLEADER: ['picklist-approve', 'picklist-complete', 'picklist-extra'],
      CHECKER: ['picklist-check'],
      INSPECTOR: ['picklist-qa-check'],
      REVIEWER: ['report', 'picklist-detail'],
    },
    Filling: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
      LEADERLINE: ['order-ready'],
      TEAMLEADER: ['picklist-approve', 'picklist-complete', 'picklist-extra', 'order-receipt-approval'],
      CHECKER: ['picklist-check'],
      REVIEWER: ['report', 'picklist-detail'],
    },
    All: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
      LEADERLINE: ['order-ready'],
      TEAMLEADER: ['picklist-approve', 'picklist-complete', 'picklist-extra'],
      CHECKER: ['picklist-check'],
      INSPECTOR: ['picklist-qa-check'],
      REVIEWER: ['report', 'picklist-detail'],
    }
  },
  Warehouse: {
    Mixing: {
      INVENTORY: ['good-issue-order', 'picklist-return', 'good-reverse-order']
    },
    Filling: {
      INVENTORY: ['good-issue-order', 'picklist-return', 'order-receipt-approval', 'good-reverse-order']
    },
    All: {
      INVENTORY: ['good-issue-order', 'picklist-return', 'order-receipt-approval', 'good-reverse-order']
    }
  },
  QC: {
    Mixing: {
      LEADERLINE: ['order-ready'],
      INSPECTOR: ['picklist-qa-check'],
      APPROVER: ['bulk-inspection'],
      BULKAPPROVER: ['bulk-inspection'],
      REVIEWER: ['report', 'picklist-detail']
    },
    Filling: {
      LEADERLINE: ['order-ready'],
      INSPECTOR: ['waste-return', 'fg-inspection'],
      ADMIN: ['order-claim', 'users'],
      APPROVER: ['fg-inspection','order-receipt-approval'],
      REVIEWER: ['report', 'picklist-detail']
    },
    All: {
      LEADERLINE: ['order-ready'],
      INSPECTOR: ['picklist-qa-check'],
      APPROVER: ['bulk-inspection'],
      BULKAPPROVER: ['bulk-inspection'],
      REVIEWER: ['report', 'picklist-detail']
    }
  },
  QS: {
    All: {
      REVIEWER: ['report', 'picklist-detail'],
    }
  },
  FA: {
    All: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
      REVIEWER: ['report', 'picklist-detail'],
      PICKLIST: ['picklist-detail'],
      APPROVER: ['order-receipt-approval']
    }
  },
  PL: {
    All: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
      LEADERLINE: ['order-ready'],
      PICKLIST: ['picklist-detail']
    }
  },
  PM: {
    All: {
      LEADERLINE: ['order-ready'],
      ADMIN: ['order-wait-confirm'],
    }
  },
  RD: {
    Mixing: {
      PICKLIST: ['picklist-detail']
    },
    All: {
      PICKLIST: ['picklist-detail']
    }
  },
  PK: {
    Filling: {
      PICKLIST: ['picklist-detail']
    },
    All: {
      PICKLIST: ['picklist-detail']
    }
  },
  PO: {
    All: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
    }
  },
  IT: {
    Mixing: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
    },
    Filling: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
    },
    All: {
      ADMIN: ['order-wait-confirm', 'master', 'users'],
    }
  }
}